import styled from 'styled-components'
import { OrderedList } from 'components/list'

export const EntitiesList = styled(OrderedList)`
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    margin-block-end: var(--__huma-component-modal-content-padding);
    padding-inline: var(--__huma-component-modal-content-padding);

    &.large {
        row-gap: 24px;
    }
`